// API Base URL - supports both Vite (import.meta.env) and CRA (process.env)
export const API_BASE_URL =
  import.meta.env?.VITE_API_BASE ||
  (typeof process !== "undefined" && process.env?.REACT_APP_API_BASE) ||
  "";

export const BASE_URL = "/";
export const USERS_URL = "/usermicroservice/api";
export const ASSETS_URL = "/assetmicroservice/api";
export const MAINTENANCE_URL = "/maintenancemicroservice/api";
export const FEEDBACK_URL = "/feedbackservice/api";
export const VENDOR_URL = "/vendorservice/api";
export const ATTENDANCE_URL = "/attendanceservice/api";
export const LEAVE_URL = "/attendanceservice/api";
export const OVERTIME_URL = "/attendanceservice/api/overtime";
